var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-header-dropdown',{staticClass:"app_header_dropdown",attrs:{"heading":_vm.$t('profile.profile'),"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }